"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ALL_PRODUCT_TREE_NODES = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_ALL_PRODUCT_TREE_NODES = (0, gql_1.gql)(`
  query productTreeNodes(
    $productTreeId: ID!,
    $filter: ProductTreeNodeFilter,
    $first: Int,
    $after: ID,
    $search: String,
  ) {
    productTreeNodes(ancestralProductTreeId: $productTreeId, filter: $filter, first: $first, search: $search, after: $after) {
      edges {
        node {
          id
          title
          description
        }
      }
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`);
